import * as main from '../../constants/main'

export default (state = {}, action) => {
    switch (action.type) {
        case main.MAIN_REDIRECT:
            return { ...state, redirectTo: action.payload }
        default:
            return state
    }
}